import { NotificationService } from 'src/app/shared/services/notification.service';
import { UserRole } from './../../follow-ups/models/deviation';
import { DomSanitizer } from '@angular/platform-browser';
import {
  inject,
  Component,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  OnDestroy
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';

import { Rights, Status } from './../../../_models/feature';
import { HelperService, PdfSetting } from './../../../_services/helper.service';

import { BaseServices } from './../../kuba.services';
import { Timetable } from '../models/index';
import { EmployeeServices } from '../services/employee.services';
import { TimetableServices } from '../../time-table/services/timetable.service';
import { SelectItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { Table } from 'primeng/table';
import { Subscription, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'timetablelist',
  templateUrl: 'employee-timetable-list.component.html',
  standalone: false
})
export class EmployeeTimetableComponent implements OnInit, OnDestroy {
  //#region variables
  private readonly notifications = inject(NotificationService);
  @ViewChildren('tableCheckbox') tableCheckboxes: QueryList<any>;
  headerCheckboxChecked: boolean = false;

  @ViewChild('timetableTable', { static: false }) timetableTable: Table;
  months: any[];
  years: any[];
  timetables: Timetable[];
  TimetableForm: FormGroup;
  filterForm: FormGroup;
  employeeId: number;
  startDate: Date;
  endDate: Date;
  videoUrl: string;
  safeURL: any;
  statusList: SelectItem[];
  additionalData: any;
  isVideo = false;
  totalHoursSpent: any;
  rowsPerPageOptions: any = [10, 20, 50, 100];
  isApproveTimetable: boolean;
  userId: any;
  selectedTimetable: any[];
  isTimeTableSelected: boolean;
  filteredValue: any;
  checkedAll: boolean;
  isApproveTimeTableRight: boolean;
  isUser: boolean;
  private subscriptions: Subscription[] = [];

  // Pagination variables
  currentPage: number = 1;
  pageSize: number = 20;
  totalItems: number = 0;
  totalPages: number = 0;
  isLoading: boolean = false;
  first: number = 0;

  // Filter variables
  workTypeFilter: string = '';
  employeeNameFilter: string = '';
  originFilter: string = '';
  approverNameFilter: string = '';
  statusFilter: string = '';
  startDateFilter: Date | null = null;
  endDateFilter: Date | null = null;
  monthFilter: number | null = null;
  yearFilter: number | null = null;

  // Sorting variables
  sortField: string = 'Default';
  sortOrder: string = 'ASC';

  // Debounce subject for filter changes
  private filterChangeSubject = new Subject<string>();

  selectedYear: any;
  selectAllChecked: any;
  selectedTimetable1: number;
  checkedCount: number;
  // #endregion

  //#region constructor

  /**
   * constructor
   * @param employeeServices {EmployeeServices}
   * @param timetableServices {TimetableServices}
   * @param _fb {FormBuilder}
   * @param route {ActivatedRoute}
   * @param confirmationService {ConfirmationService}
   */
  constructor(
    private employeeServices: EmployeeServices,
    private timetableServices: TimetableServices,
    private _fb: FormBuilder,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private translate: TranslateService
  ) {
    
    this.subscriptions.push(
      this.translate.stream('FILENAME').subscribe(val => {
        this.additionalData = {
          fileName: val.EMPLOYEE_TIMETABLE_LIST,
          header: 'Employee Timetable List',
          businessId: BaseServices.BusinessId,
          cultureInfo: BaseServices.userCultureInfo(),
          columnNames: [
            { title: 'Employee Name', dataKey: 'EmployeeName' },
            { title: 'Project Name', dataKey: 'ProjectName' },
            { title: 'Type of Work', dataKey: 'ProjectWorkTypeName' },
            { title: 'Start Date', dataKey: 'StartDate' },
            { title: 'End Date', dataKey: 'EndDate' },
            { title: 'Start Time', dataKey: 'StartTime' },
            { title: 'End Time', dataKey: 'EndTime' },
            { title: 'Break', dataKey: 'BreakTime' },
            { title: 'Hours Spent', dataKey: 'HoursSpent' },
            { title: 'Comments', datakey: 'Comments' },
            { title: 'Approval Person', dataKey: 'ApprovalUser' },
            { title: 'Approval Date', dataKey: 'ApprovalDate' },
            { title: 'Status', dataKey: 'StatusText' }
          ]
        };
      })
    );
  }

  // #endregion

  //#region page-events

  /**
   * getting employee id,binding the datatable based on id,binding yesr and month function call
   */
  ngOnInit() {
    document.querySelector('body').classList.remove('opened');
    this.isUser = +BaseServices.roleId === UserRole.USER ? false : true;
    this.checkApprovelTimeTableRights();
    this.selectedTimetable = [];
    this.userId = BaseServices.UserId;
    this.bindDropdowns();
    this.TimetableForm = this._fb.group({
      FromDate: [''],
      EndDate: [''],
      Month: [],
      Year: []
    });

    // Initialize filter form
    this.filterForm = this._fb.group({
      workType: [''],
      employeeName: [''],
      origin: [''],
      approverName: [''],
      status: ['']
    });

    let eid = this.route.snapshot.params['tid'];
    this.employeeId = +eid;
    
    // Setup filter debouncing
    this.setupFilterDebounce();
    
    // Load timetables with pagination
    this.loadTimetables();
    
    this.bindYears();
    this.bindMonths();
  }

  gridData() {
    var resArr = [];
    this.timetables.forEach(function (item) {
      var i = resArr.findIndex(x => x.Id == item.Id);
      if (i <= -1) {
        resArr.push(item);
      }
    });
    this.timetables = resArr;
    if (this.timetables !== null) {
      this.timetables = this.timetables.filter(x => x.EndDate !== null);
    }
    let currentYear = new Date().getFullYear();
    this.bindTimetableGrid(this.timetables);
    this.timetables.forEach(element => {
      this.timetables = this.timetables.filter(
        (item: any) => item.Year == String(currentYear)
      );
    });
  }
  checkApprovelTimeTableRights() {
    let userData = this.route.snapshot.data['userData'];
    let rightsId = Rights.APPROVE_TIMETABLE;
    if (userData) {
      let userRights = JSON.parse(userData.Rights);
      this.isApproveTimetable = BaseServices.checkRightsForAccess(
        userRights,
        rightsId
      );
    }
  }

  // #endregion

  //#region Control-events
  /**
   * get current date
   */
  getCurrentDate() {
    let dateFormat = new Date();
    return {
      year: dateFormat.getFullYear(),
      month: dateFormat.getMonth() + 1,
      day: dateFormat.getDate() - 1
    };
  }
  /**
   * Delete employee timtable
   * @param timetables {any}
   */
  deleteTimetable(timetables: any) {
    this.confirmationService.confirm({
      message: this.translate.instant('DELETE_THIS_RECORD'),
      accept: () => {
        this.subscriptions.push(
          this.employeeServices
            .deleteTimetable(timetables)
            .subscribe(isTimeTableDeleted => {
              if (isTimeTableDeleted) {
                this.notifications.success('UI_NOTIFICATIONS.DELETED');
                this.loadTimetables();
              }
            })
        );
      }
    });
  }
  timetableByBusiness() {
    this.subscriptions.push(
      this.employeeServices
        .getAllTimetableByBusinessId(BaseServices.BusinessId)
        .subscribe((timetableBusinessList: any) => {
          this.timetables = timetableBusinessList;
          this.gridData();
        })
    );
  }
  timetableByEmployee() {
    this.subscriptions.push(
      this.employeeServices
        .getTimeTableByEmployeeId(this.employeeId)
        .subscribe(timetableEmployeeList => {
          this.timetables = timetableEmployeeList;
        })
    );
  }
  /**
   * start date change event
   * @param event {IMyDateModel}
   */
  onTimeTableStartDateChanged(date: Date) {
  this.startDate = date;
  if (date) {
    this.TimeTableDateRangeFilter(this.startDate, this.endDate);
  } else {
    this.bindTimetable();
  }
}

  onHeaderCheckboxClick() {
    // Toggle the header checkbox state
    this.headerCheckboxChecked = !this.headerCheckboxChecked;

    // You can get the number of checkboxes checked in the table
    this.checkedCount = this.tableCheckboxes.filter(cb => cb.checked).length;
  }

  /**
   * End date change event
   * @param event {IMyDateModel}
   */
  onTimeTableEndDateChanged(date: Date) {
  this.endDate = date;
  if (date) {
    this.TimeTableDateRangeFilter(this.startDate, this.endDate);
  } else {
    this.bindTimetable();
  }
}
  /**
   * Month change dropdown event for filter
   * @param e {any}
   * @param monthDropdown {any}
   */
  onMonthChanged(e: any, monthDropdown: any) {
    if (e.value) {
      let selectedMonth = monthDropdown.selectedOption.value;
      // Remove leading zeros and convert to number
      this.monthFilter = parseInt(String(selectedMonth).replace(/^0+/, ''));
    } else {
      this.monthFilter = null;
    }
    this.currentPage = 1;
    this.loadTimetables();
  }
  
  /**
   * year change dropdown event for filter
   * @param e {any}
   * @param yearDropdown {any}
   */
  onYearChanged(e: any, yearDropdown: any) {
    if (e.value) {
      this.yearFilter = yearDropdown.selectedOption.value;
    } else {
      this.yearFilter = null;
    }
    this.currentPage = 1;
    this.loadTimetables();
  }

  /**
   * refresh datatable
   */
  refreshTable() {
    this.TimetableForm = this._fb.group({
      FromDate: [''],
      EndDate: [''],
      Month: [],
      Year: []
    });
    
    // Reset all filters
    this.workTypeFilter = '';
    this.employeeNameFilter = '';
    this.originFilter = '';
    this.approverNameFilter = '';
    this.statusFilter = '';
    this.startDateFilter = null;
    this.endDateFilter = null;
    this.monthFilter = null;
    this.yearFilter = null;
    this.currentPage = 1;
    
    // Reset forms
    this.filterForm.reset();
    
    this.loadTimetables();
  }
  bindTimetable() {
    // Data is now loaded via loadTimetables() method
    // No need to access resolver data
  }
  /**
   * Export PDF
   */
  exportPdf() {
    let pdfSetting = new PdfSetting();
    pdfSetting.date = HelperService.formatDate(new Date());
    pdfSetting.businessName = BaseServices.BusinessName;
    pdfSetting.pageHeader = 'Employee Timetable List';
    let columns: any = [
      { title: 'Employee Name', dataKey: 'EmployeeName' },
      { title: 'Project Name', dataKey: 'ProjectName' },
      { title: 'Type of Work', dataKey: 'ProjectWorkTypeName' },
      { title: 'Work Date', dataKey: 'StartDate' },
      { title: 'End Date', dataKey: 'EndDate' },
      { title: 'Start Time', dataKey: 'StartTime' },
      { title: 'End Time', dataKey: 'EndTime' },
      { title: 'Hours Spent', dataKey: 'HoursSpent' },
      { title: 'Comments', datakey: 'Comments' },
      { title: 'Approver Name', dataKey: 'ApproverName' },
      { title: 'Approval Date', dataKey: 'ApprovalDate' },
      { title: 'Status', dataKey: 'Status' }
    ];
    HelperService.generatePdf(
      this.timetables,
      columns,
      'Employee-Timetable',
      pdfSetting,
      'l'
    );
  }

  // #endregion

  //#region methods

  /**
   * Binding year dropdown
   */
  bindYears() {
    let currentYear = new Date().getFullYear();
    this.bindTimetableGrid(this.timetables);
    this.timetables.forEach(element => {
      this.timetables = this.timetables.filter(
        (item: any) => item.Year == String(currentYear)
      );
    });
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.years = [];
        this.years.push({ label: val.SELECT, value: null });
        for (let n = currentYear - 9; n <= currentYear + 1; n++) {
          this.years.push({ label: n, value: n });
        }
      })
    );
  }

  /**
   * TimeTable DateRange Filter
   * @param StartDate {any}
   * @param EndDate {any}
   */
  TimeTableDateRangeFilter(StartDate: any, EndDate: any) {
    // Update date filters and reload data
    this.startDateFilter = StartDate;
    this.endDateFilter = EndDate;
    this.currentPage = 1;
    this.loadTimetables();
  }
  /**
   * to bing time table list
   * @param timeTableList {any}
   */
  bindTimetableGrid(timeTableList: any) {
    this.timetables = [];
    let listForSpentHours;
    if (timeTableList) {
      if (timeTableList.length > 20) {
        listForSpentHours = timeTableList.slice(0, 20);
        this.totalHoursSpent = HelperService.addTimes(
          listForSpentHours,
          'HoursSpent'
        );
      } else {
        this.totalHoursSpent = HelperService.addTimes(
          timeTableList,
          'HoursSpent'
        );
      }

      timeTableList.forEach((timeTable: any) => {
        timeTable.Month = `${new Date(timeTable.StartDate).getMonth() + 1}`;
        timeTable.Year = `${new Date(timeTable.StartDate).getFullYear()}`;
        this.timetables.push(timeTable);
        this.rowsPerPageOptions = [10, 20, 50, 100];
        if (this.timetables.length > 100) {
          this.rowsPerPageOptions.push(this.timetables.length);
        }
      });
    }
  }
  /**
   * filter change event
   * @param event {any}
   */
  employeeFilterChange(event: any) {
    this.filteredValue = event.filteredValue;
    if (this.filteredValue.length > 0) {
      this.totalHoursSpent = HelperService.addTimes(
        this.filteredValue,
        'HoursSpent'
      );
    } else {
      this.totalHoursSpent = 0;
    }
  }
  /**
   * pagination change
   * @param first {number}
   * @param end {number}
   */
  employeePageChange(event: any) {
    let list: any = this.timetables.slice(
      event.first,
      event.first + event.rows
    );
    if (list.length > 0) {
      this.totalHoursSpent = HelperService.addTimes(list, 'HoursSpent');
    } else {
      this.totalHoursSpent = 0;
    }
  }

  /**
   * bind dropdown
   */
  bindDropdowns() {
    this.subscriptions.push(
      this.translate.stream('SELECT_STATUSES').subscribe(val => {
        this.statusList = [];
        this.statusList.push(
          { label: val.SELECT, value: null },
          { label: val.OPEN, value: Status.Open.toString() },
          { label: val.APPROVED, value: Status.Approved.toString() },
          { label: val.REJECTED, value: Status.Rejected.toString() }
        );
      })
    );
  }
  /**
   * to filter status in list
   * @param e {event}
   * @param statusDropdown {any}
   */
  onStatusChanged(e: any, statusDropdown: any) {
    if (e.value) {
      // Map status ID to status name for API using Status enum
      const statusMap: { [key: number]: string } = {
        [Status.Open]: 'Open',
        [Status.Approved]: 'Approved',
        [Status.Rejected]: 'Rejected'
      };
      this.statusFilter = statusMap[parseInt(statusDropdown.selectedOption.value)] || '';
    } else {
      this.statusFilter = '';
    }
    this.currentPage = 1;
    this.loadTimetables();
  }

  checked(value: any) {
    if (this.selectedTimetable.length > 0) {
      if (value.status === true) {
        this.selectedTimetable.push(value.Id);
      } else if (value.status === false) {
        this.checkedAll = false;
        this.selectedTimetable = this.selectedTimetable.filter(
          (x: any) => x !== value.Id
        );
      }
    } else {
      if (value.status === true) {
        this.selectedTimetable.push(value.Id);
      } else {
        this.selectedTimetable = [];
      }
    }
  }

  checkAll(event: any) {
    let list: any = [];
    if (event) {
      this.checkedAll = true;
      if (this.filteredValue && this.filteredValue.length > 0) {
        this.filteredValue.forEach((element: any) => {
          list.push(element.Id);
        });
        _.forEach(this.filteredValue, (item: any) => {
          if (event) {
            item.status = true;
          } else {
            item.status = false;
            this.selectedTimetable = [];
          }
        });
        if (list.length > 0) {
          list.forEach((element: any) => {
            this.selectedTimetable.push(element);
          });
        }
      } else {
        list = this.timetables.filter(x => x.ApprovalUserId === this.userId && x.Status === Status.Open
        );
        _.forEach(list, (item: any) => {
          if (event) {
            item.status = true;
          } else {
            item.status = false;
            this.selectedTimetable = [];
          }
        });
        if (list.length > 0) {
          list.forEach((element: any) => {
            this.selectedTimetable.push(element.Id);
          });
        }
      }
      this.selectAllChecked = event.checked;
    } else {
      _.forEach(this.timetables, (item: any) => {
        item.status = false;
        this.selectedTimetable = [];
      });
    }
  }

  /**
   * employee multi delete
   * @param selectedTimetable
   */
  approveMultiple(selectedTimetable: any) {
    let selectedIds: any = [];
    this.selectedTimetable.forEach((element: any) => {
      selectedIds.push(element.Id);
    });
    if (selectedIds.length > 0) {
      this.confirmationService.confirm({
        message: this.translate.instant('CONFIRMATION_APPROVAL'),
        accept: () => {
          this.subscriptions.push(
            this.employeeServices
              .approveTimeTable(selectedIds)
              .subscribe(result => {
                if (result) {
                  this.notifications.success('UI_NOTIFICATIONS.SAVED');
                  this.checkedAll = false;
                  this.selectedTimetable = [];
                  this.loadTimetables();
                }
              })
          );
        }
      });
    } else {
      this.isTimeTableSelected = true;
    }
  }

  //Binding months dropdown
  bindMonths(){
    let currentYear = new Date().getFullYear();
    this.selectedYear = { label: currentYear, value: currentYear };
    this.subscriptions.push(
      this.translate.stream('SELECT_MONTH').subscribe(val => {
        this.months = [];
        this.months.push(
          { label: val.SELECT, value: null },
          { label: val.JANUARY, value: '01' },
          { label: val.FEBRUARY, value: '02' },
          { label: val.MARCH, value: '03' },
          { label: val.APRIL, value: '04' },
          { label: val.MAY, value: '05' },
          { label: val.JUNE, value: '06' },
          { label: val.JULY, value: '07' },
          { label: val.AUGUST, value: '08' },
          { label: val.SEPTEMBER, value: '09' },
          { label: val.OCTOBER, value: '10' },
          { label: val.NOVEMBER, value: '11' },
          { label: val.DECEMBER, value: '12' }
        );
      })
    );
  }

  /**
   * Format date for API
   */
  private formatDateForApi(date: Date): string {
    return date.toISOString().split('T')[0]; // Returns YYYY-MM-DD format
  }

  /**
   * Load timetables with pagination
   */
  loadTimetables() {
    if (this.isLoading) return;
    
    this.isLoading = true;
    
    // MIRRORED FROM EMPLOYEE LIST - use PascalCase for C# binding
    const filter: any = {
      PageNumber: this.currentPage,
      PageSize: this.pageSize,
      SortField: this.sortField,
      SortOrder: this.sortOrder
    };

    // Only add non-null filter values (using PascalCase for C# binding)
    if (this.workTypeFilter && this.workTypeFilter.trim()) {
      filter.WorkType = this.workTypeFilter;
    }
    if (this.employeeNameFilter && this.employeeNameFilter.trim()) {
      filter.EmployeeName = this.employeeNameFilter;
    }
    if (this.originFilter && this.originFilter.trim()) {
      filter.Origin = this.originFilter;
    }
    if (this.approverNameFilter && this.approverNameFilter.trim()) {
      filter.ApproverName = this.approverNameFilter;
    }
    if (this.statusFilter && this.statusFilter.trim()) {
      filter.Status = this.statusFilter;
    }
    if (this.startDateFilter) {
      filter.StartDate = this.formatDateForApi(this.startDateFilter);
    }
    if (this.endDateFilter) {
      filter.EndDate = this.formatDateForApi(this.endDateFilter);
    }
    if (this.monthFilter !== null && this.monthFilter !== undefined) {
      filter.Month = this.monthFilter;
    }
    if (this.yearFilter !== null && this.yearFilter !== undefined) {
      filter.Year = this.yearFilter;
    }
    
    // IMPORTANT: businessId is now mandatory for security - always scoped to a business
    const businessId = BaseServices.BusinessId;
    
    this.subscriptions.push(
      this.timetableServices.getPagedTimetables(businessId, filter).subscribe(
        (response: any) => {
          // MIRRORED FROM EMPLOYEE LIST - exact property names from PagedResponse
          this.timetables = response.Items || [];
          
          // Convert date strings to Date objects for proper formatting
          this.timetables.forEach(item => {
            if (item.StartDate && typeof item.StartDate === 'string') {
              item.StartDate = new Date(item.StartDate);
            }
            if (item.EndDate && typeof item.EndDate === 'string') {
              item.EndDate = new Date(item.EndDate);
            }
          });
          
          this.totalItems = response.TotalCount || 0;
          this.totalPages = response.TotalPages || 0;  // Fixed: Capital T
          this.currentPage = response.PageNumber || 1;  // Fixed: Capital P and N
          this.pageSize = response.PageSize || 20;      // Fixed: Capital P and S
          
          // Calculate total hours spent for current page
          if (this.timetables.length > 0) {
            this.calculateTotalHoursSpent(this.timetables);
          } else {
            this.totalHoursSpent = 0;
          }
          
          this.isLoading = false;
        },error => {
          this.isLoading = false;
        }
      )
    );
  }

  /**
   * Calculate total hours spent from timetable list
   */
  private calculateTotalHoursSpent(timetables: any[]) {
    if (!timetables || timetables.length === 0) {
      this.totalHoursSpent = '00:00:00';
      return;
    }
    
    let totalSeconds = 0;
    timetables.forEach(item => {
      if (item.HoursSpent) {
        const parts = item.HoursSpent.toString().split(':');
        if (parts.length === 3) {
          totalSeconds += parseInt(parts[0]) * 3600 + parseInt(parts[1]) * 60 + parseInt(parts[2]);
        }
      }
    });
    
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    
    this.totalHoursSpent = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  /**
   * Setup filter debounce
   */
  private setupFilterDebounce() {
    this.subscriptions.push(
      this.filterChangeSubject
        .pipe(
          debounceTime(500)
        )
        .subscribe(() => {
          this.currentPage = 1;
          this.loadTimetables();
        })
    );
  }

  /**
   * Trigger filter change
   */
  private triggerFilterChange() {
    this.filterChangeSubject.next('filter');
  }

  /**
   * Handle page change event
   */
  onPageChange(event: any) {
    this.currentPage =event.first / event.rows + 1;
    this.pageSize = event.rows;
    this.first = event.first;
    this.loadTimetables();
  }

  /**
   * Handle sort event
   */
  onSort(event: any) {
    this.sortField = event.field || 'Default';
    this.sortOrder = event.order === 1 ? 'ASC' : 'DESC';
    this.loadTimetables();
  }

  /**
   * Filter change handlers
   */
  onWorkTypeFilterChange(value: string) {
    this.workTypeFilter = value;
    this.filterForm.patchValue({ workType: value });
    this.triggerFilterChange();
  }

  onEmployeeNameFilterChange(value: string) {
    this.employeeNameFilter = value;
    this.filterForm.patchValue({ employeeName: value });
    this.triggerFilterChange();
  }

  onOriginFilterChange(value: string) {
    this.originFilter = value;
    this.filterForm.patchValue({ origin: value });
    this.triggerFilterChange();
  }

  onApproverNameFilterChange(value: string) {
    this.approverNameFilter = value;
    this.filterForm.patchValue({ approverName: value });
    this.triggerFilterChange();
  }

  /**
   * Export timetables with current filters and sorting
   * @param format Export format (XLSX or PDF)
   */
  exportTimetables(format: string) {
    const filter: any = {
      PageNumber: 1,
      PageSize: 100000,
      SortField: this.sortField,
      SortOrder: this.sortOrder
    };

    // Apply all current filters
    if (this.workTypeFilter && this.workTypeFilter.trim()) {
      filter.WorkType = this.workTypeFilter;
    }
    if (this.employeeNameFilter && this.employeeNameFilter.trim()) {
      filter.EmployeeName = this.employeeNameFilter;
    }
    if (this.originFilter && this.originFilter.trim()) {
      filter.Origin = this.originFilter;
    }
    if (this.approverNameFilter && this.approverNameFilter.trim()) {
      filter.ApproverName = this.approverNameFilter;
    }
    if (this.statusFilter && this.statusFilter.trim()) {
      filter.Status = this.statusFilter;
    }
    if (this.startDateFilter) {
      filter.StartDate = this.formatDateForApi(this.startDateFilter);
    }
    if (this.endDateFilter) {
      filter.EndDate = this.formatDateForApi(this.endDateFilter);
    }
    if (this.monthFilter !== null && this.monthFilter !== undefined) {
      filter.Month = this.monthFilter;
    }
    if (this.yearFilter !== null && this.yearFilter !== undefined) {
      filter.Year = this.yearFilter;
    }

    // IMPORTANT: businessId is now mandatory for security - always scoped to a business
    const businessId = BaseServices.BusinessId;
    const headerName = this.translate.instant('TIME_TABLE') || 'Employee Timetable List';
    const cultureInfo = BaseServices.userCultureInfo();
    const mode = 1; // 1 = Landscape

    this.timetableServices.exportTimetablesToExcel(
      businessId, 
      filter, 
      format, 
      headerName, 
      mode, 
      cultureInfo
    ).subscribe({
      next: (blob: Blob) => {
        // Create download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const extension = format === 'XLSX' ? '.xlsx' : format === 'PDF' ? '.pdf' : '.docx';
        link.download = `${headerName}_${new Date().toISOString().slice(0, 10)}${extension}`;
        link.click();
        window.URL.revokeObjectURL(url);
      },
      error:err => {
        console.error('Error exporting timetables:', err);
        
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });
  }
  // #endregion
}
